import styled from 'styled-components';
import { baseVariables } from '../../styles';

export const StyledRadioButtonDiv = styled.div`
  .disabled {
    color: ${baseVariables.color['neutral30']};
  }
`;
